export { default } from '@material-ui/icons/SaveAlt';
